document.addEventListener("DOMContentLoaded", () => {
  const productSearchInput = document.getElementById("product-search-input");
  const autocompleteList = document.getElementById("autocomplete-list");
  const resetButton = document.getElementById("reset-button");
  const filterIndicator = document.getElementById("filter-indicator");
  const currentFilter = document.getElementById("current-filter");
  const removeFilterBtn = document.getElementById("remove-filter-btn");
  const projectSections = document.querySelectorAll(".w-project-section");

  // Obtener productos únicos para autocompletar
  const productMap = new Map();
  document.querySelectorAll(".w3-product-item").forEach((item) => {
    const productName = item.dataset.product;
    const productImage = item.dataset.image || "https://via.placeholder.com/40"; // Imagen por defecto si no hay
    const productTags = item.dataset.tags || ""; // Product tags

    if (productTags || (productName && !productMap.has(productName))) {
      const titleWithTags = productName + " *** [" + productTags + "]";
      productMap.set(titleWithTags, productImage);
    }
  });

  const products = Array.from(productMap, ([name, image]) => ({ name, image }));

  // Mostrar sugerencias con imágenes
  function showSuggestions(value) {
    const matches = products.filter((product) =>
      product.name.toLowerCase().includes(value.toLowerCase())
    );

    if (matches.length > 0) {
      autocompleteList.innerHTML = matches
        .map(
          (product) =>
            `<div class="autocomplete-suggestion" data-value="${product.name
              .split(" ***")
              .shift()}" style="display: flex; align-items: center; padding: 5px; cursor: pointer;">
                <img src="${product.image}" alt="${product.name
              .split(" ***")
              .shift()}" style="width: 50px; height: 50px;  margin-right: 10px;">
                <span>${product.name.split(" ***").shift()}</span>
              </div>`
        )
        .join("");
      autocompleteList.style.display = "block";
    } else {
      autocompleteList.innerHTML = `<div class="autocomplete-suggestion">There are no matches</div>`;
      autocompleteList.style.display = "block";
    }
  }

  // Mostrar todos los proyectos
  function showAllProjects() {
    projectSections.forEach((section) => {
      section.style.display = "flex";
      section.style.opacity = "1";
    });

    updateTotalProjectsCount(projectSections.length);
  }

  // Filtrar proyectos por producto
  function filterProjectsByProduct(productName) {
    let matchedCount = 0;
    projectSections.forEach((section) => {
      const sectionProducts = section.querySelectorAll(".w3-product-item");
      let matches = false;

      sectionProducts.forEach((product) => {
        const _productTags = product.dataset.tags.toLowerCase();
        const _productNameInputValue = productName.toLowerCase();
        const _productName = product.dataset.product.toLowerCase();
        if (_productName === _productNameInputValue || _productTags.includes(_productNameInputValue)) {
          matches = true;
        }
      });

      if (matches) {
        section.style.display = "flex";
        section.style.opacity = "1";
        matchedCount++;
      } else {
        section.style.opacity = "0";
        setTimeout(() => {
          section.style.display = "none";
        }, 100);
      }
    });

    updateTotalProjectsCount(matchedCount);

    // Mostrar filtro activo
    setFilterIndicator(productName);
  }

  function updateTotalProjectsCount(matchedCount) {
    const projectTotalResults = document.querySelector('.project-total-results');
    projectTotalResults.querySelector('.project-total-results__count').textContent = matchedCount;
    projectTotalResults.querySelector('.project-total-results__verbage').textContent = matchedCount > 1 ? projectTotalResults.getAttribute('data-plural-verbage') : projectTotalResults.getAttribute('data-singular-verbage');
  }

  // Establecer indicador de filtro activo
  function setFilterIndicator(productName) {
    filterIndicator.classList.remove("hidden");
    currentFilter.textContent = productName;
    productSearchInput.value = productName;
  }

  // Eliminar filtro activo y ocultar las sugerencias
  function clearFilter() {
    filterIndicator.classList.add("hidden");
    currentFilter.textContent = "";
    productSearchInput.value = "";
    showAllProjects();
    autocompleteList.style.display = "none"; // Ocultar las sugerencias
  }

  // Evento de entrada para mostrar sugerencias
  // productSearchInput.addEventListener("input", () => {
  //   const inputValue = productSearchInput.value.trim();
  //   if (inputValue) {
  //     // showSuggestions(inputValue);
  //   } else {
  //     autocompleteList.style.display = "none"; // Ocultar sugerencias cuando no hay texto
  //   }
  // });

  productSearchInput.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      const inputValue = productSearchInput.value.trim();
      if (inputValue) {
        autocompleteList.style.display = "none";
        filterProjectsByProduct(inputValue);
      }
    }
  });

  // Seleccionar una sugerencia y aplicar el filtro
  autocompleteList.addEventListener("click", (e) => {
    const suggestion = e.target.closest(".autocomplete-suggestion");
    if (suggestion) {
      const productName = suggestion.dataset.value;
      productSearchInput.value = productName;
      autocompleteList.style.display = "none";
      filterProjectsByProduct(productName);
    }
  });

  // Restablecer barra de búsqueda y ocultar las sugerencias
  resetButton.addEventListener("click", () => {
    clearFilter();
    autocompleteList.style.display = "none"; // Ocultar las sugerencias al restablecer
  });

  removeFilterBtn.addEventListener("click", () => {
    clearFilter();
    autocompleteList.style.display = "none"; // Ocultar las sugerencias al eliminar filtro
  });
});
